import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Table } from '../../../common/table'
import { TextEllipsisStaticLine } from './../../../common/textEllipsis/TextEllipsisStaticLine'
import classes from './index.module.scss'

export const TableItem = ({
  title,
  subTitle,
  note,
  indicatorName,
  dataColIds,
  ids,
  getDataFromRedux,
  renderDetail = () => {},
  isDynamicReport,
}) => {
  const COLUMN_ID = {
    STT: 'STT',
    NAME: 'name',
    ...(dataColIds || {}),
  }

  const schema = Object.keys(COLUMN_ID).map((key, index) => {
    const colId = COLUMN_ID[key]
    const title =
      'portfolio.summary.' + (colId === COLUMN_ID.NAME ? indicatorName : key)

    return {
      colId,
      title,
      isI18n: true,
      isHtml: true,
      parentThStyle: { verticalAlign: 'baseline' },
      thStyle: {
        justifyContent: index > 1 ? 'end' : 'start',
        textAlign: index > 1 ? 'right' : 'left',
      },
      tdStyle: {
        width: colId === COLUMN_ID.NAME ? '100%' : '',
        textAlign: index > 1 ? 'right' : 'left',
      },
      render: (data, { rowId, rowIndex }) => {
        switch (colId) {
          case COLUMN_ID.STT:
            return rowIndex + 1
          case COLUMN_ID.NAME:
            return isDynamicReport ? (
              data
            ) : (
              <TextEllipsisStaticLine
                text={data}
                isI18n={false}
                lineClamp={1}
              />
            )

          default:
            return renderDetail({ rowId, colId, data })
        }
      },
    }
  })

  return (
    <div>
      <div className={classes.title}>
        <Element
          elementName="span"
          className="fw600"
          style={{ fontSize: 14, color: '#191D25' }}
        >
          <Translate value={title} />
        </Element>
        &nbsp;
        {subTitle && (
          <Element elementName="span" style={{ color: '#3A414B' }}>
            <Translate value={subTitle} />
          </Element>
        )}
        <Element style={{ color: '#9C9C9C', marginTop: 3 }}>
          <Translate value={note} />
        </Element>
      </div>

      <div>
        <Table
          ids={ids}
          getDataFromRedux={getDataFromRedux}
          schema={schema}
          autoHeightMax={3000}
          isDynamicReport={isDynamicReport}
        />
      </div>
    </div>
  )
}
